import React from "react";
import { Filter, useTranslate } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { DateTimeInput } from "../../../components/inputs";
import { AdminLogModuleType } from "../../../entities/AdminLogModuleType";
import { AdminLogModuleMultipleSelect } from "../components/AdminLogLevelModule";
import { AdminLogLevelSelect } from "../components/AdminLogLevelSelect";

export const AdminLogsFilter = (props) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<DateTimeInput
				source="created_at.created_at_from"
				label={translate("osfc.filters.created_at.from")}
				withLocalTimeZone
			/>
			<DateTimeInput
				source="created_at.created_at_to"
				label={translate("osfc.filters.created_at.to")}
				withLocalTimeZone
			/>
			<TextInputEx source="order_id" />
			<AdminLogLevelSelect source="log_level" />
			<AdminLogModuleMultipleSelect
				source="module"
				enumObj={AdminLogModuleType}
				enumName="log-module"
			/>
			<TextInputEx source="description" />
			<TextInputEx source="data" />
		</Filter>
	);
};
